import { put, takeLatest } from 'redux-saga/effects';
import instance from '../set';
import { PickupDetailsActionCreators } from 'src/store/reducers/pickupDetails/action-creators';
import { PickupDetailsActionEnum } from 'src/store/reducers/pickupDetails/types';

function* fetchDeletePickupDetails({
  id
}: ReturnType<typeof PickupDetailsActionCreators.deletePickupDetails>) {
  try {
    const { status }: Response = yield instance.put('pickup-details/delete', id);
    yield put(PickupDetailsActionCreators.resultDeletePickupDetails(status));
  } catch (e) {
    console.log(e);
  }
}
export function* actionWatcherDeletePickupDetails() {
  yield takeLatest(PickupDetailsActionEnum.REQUEST_DELETE_PICKUPDETAILS, fetchDeletePickupDetails);
}
